import { useState, useEffect } from 'react'
import Login from './components/Login' // You'll need to create this component
import HomePage from './components/HomePage'
import { ThemeProvider, createTheme } from '@mui/material'

import { CognitoUser, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';

const theme = createTheme({
  palette: {
    primary: {
      main: '#00539B',
    },
    secondary: {
      main: '#00539B',
    },
  },
})

// TODO: add to env
const poolData = {
  UserPoolId: "us-east-2_Mbaop1Lpa",
  ClientId: "6fv2mp44hehv8abmop81aotulg",
};
const userPool = new CognitoUserPool(poolData);

export const getCurrentUserSession = (): Promise<string | null> => {
  const currentUser = userPool.getCurrentUser();
  if (!currentUser) return Promise.resolve(null);

  return new Promise((resolve, reject) => {
    currentUser.getSession((err: Error | null, session: CognitoUserSession | null)  => {
      if (err || !session?.isValid()) {
        return resolve(null);
      }

      const idToken = session.getIdToken().getJwtToken();
      resolve(idToken);
    });
  });
};

function App() {
  const [user, setUser] = useState<CognitoUser | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  useEffect(() => {

    getCurrentUserSession().then((token) => {
      if (token) {
        const currentUser = userPool.getCurrentUser();
        if (currentUser) {
          setUser(currentUser);
        }
        setIsAuthenticated(true); // your own state

      } else {
        setIsAuthenticated(false);
      }
    });
  }, []);


  const handleLogin = (isLoggedIn: boolean) => {
    setIsAuthenticated(isLoggedIn)
    const currentUser = userPool.getCurrentUser();
    if (currentUser) {
      setUser(currentUser);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <HomePage user={user} />
      )}
    </ThemeProvider>
  )
}

export default App